import React from "react";
import { Target, Compass, Factory } from "lucide-react";

const milestones = [
  { year: "2023", title: "Founded in Dharwad", desc: "VersaCorp incorporated with a vision to lead sustainable disposables in India." },
  { year: "2024", title: "Production Line Launch", desc: "Commissioned high-speed paper cup and napkin manufacturing facility at KIADB." },
  { year: "2025", title: "Pan-India Distribution", desc: "Expanded across 20+ distribution partners serving major South & West India hubs." },
  { year: "2026", title: "Custom Branding Studio", desc: "Launched in-house design + custom printing for restaurants, cafes & corporates." },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
              About VersaCorp
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold leading-[1.05] text-neutral-900">
              Built on quality. <br />
              Driven by <span className="vc-text-gradient">sustainability.</span>
            </h2>
            <p className="mt-6 text-neutral-600 text-base md:text-lg leading-relaxed">
              VersaCorp India Pvt. Ltd. is a next-generation manufacturer of eco-friendly
              disposable products. From food-grade paper cups to premium tissue napkins
              and custom printed packaging, we partner with thousands of brands that care
              about hygiene, branding, and the planet.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <Pillar icon={<Target size={18} />} title="Vision" body="To become India's most trusted sustainable disposable products manufacturer." />
              <Pillar icon={<Compass size={18} />} title="Mission" body="Deliver innovative, eco-friendly packaging solutions while protecting the environment." />
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="absolute left-[18px] top-2 bottom-2 w-px bg-neutral-200" aria-hidden />
            <ul className="space-y-8">
              {milestones.map((m, i) => (
                <li key={m.year} className="relative pl-12">
                  <span
                    className="absolute left-0 top-1 w-[38px] h-[38px] rounded-full vc-gradient flex items-center justify-center text-white text-xs font-mono-vc font-bold shadow-md"
                    style={{ animationDelay: `${i * 0.1}s` }}
                  >
                    {m.year.slice(-2)}
                  </span>
                  <div className="flex items-baseline gap-3">
                    <div className="font-display text-2xl font-bold text-neutral-900">{m.title}</div>
                    <div className="font-mono-vc text-xs text-neutral-500">{m.year}</div>
                  </div>
                  <p className="mt-2 text-neutral-600 leading-relaxed">{m.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const Pillar = ({ icon, title, body }) => (
  <div className="rounded-2xl border border-neutral-200 p-5 bg-neutral-50/60">
    <div className="w-9 h-9 rounded-lg vc-gradient text-white flex items-center justify-center mb-3">
      {icon}
    </div>
    <div className="font-display font-bold text-neutral-900">{title}</div>
    <p className="text-sm text-neutral-600 mt-1.5 leading-relaxed">{body}</p>
  </div>
);
